exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n@keyframes octicon-spin {\n\t100% {\n\t\ttransform:rotate(360deg);\n\t}\n}\n\n.octicon-animation-spin {\n\tanimation: octicon-spin 2s linear infinite;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./submodules/vscode/src/vs/base/browser/ui/octiconLabel/octicons/octicons-animations.css
// module id = 538
// module chunks = 0